import { render, staticRenderFns } from "./SelectfrightProduce.vue?vue&type=template&id=57a4bf43&scoped=true"
import script from "./SelectfrightProduce.vue?vue&type=script&lang=js"
export * from "./SelectfrightProduce.vue?vue&type=script&lang=js"
import style0 from "./SelectfrightProduce.vue?vue&type=style&index=0&id=57a4bf43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4bf43",
  null
  
)

export default component.exports